import {
    IAuthorizationService,
    IDataAccessService,
    IEventService,
    IExportService,
    IPowerBiService,
} from '@price-for-profit/micro-services';
import { PropsWithChildren, createContext, useContext } from 'react';
import { FuturePriceService, INotificationService } from 'shared/services';
import { ICustomExportService } from 'shared/services/custom-export-service';
import { IEmailAddressService } from 'shared/services/email-address-service';
import { IEventExportService } from 'shared/services/event-export-service';
import { ILambdaService } from 'shared/services/lambda-service';
import { AppConfig } from 'shared/types';

export interface ServiceContext {
    appConfig: AppConfig;
    eventService: IEventService;
    exportService: ICustomExportService;
    eventExportService: IEventExportService;
    exportMSService: IExportService;
    notificationService: INotificationService;
    emailAddressService: IEmailAddressService;
    authService: IAuthorizationService;
    powerBiService: IPowerBiService;
    lambdaService: ILambdaService;
    dataAccessService: IDataAccessService;
    futurePriceService: FuturePriceService;
}
type ServiceProviderProps = {
    context: ServiceContext;
};

const serviceContext = createContext<ServiceContext>({} as ServiceContext);

export function ProvideService({ children, context }: PropsWithChildren<ServiceProviderProps>) {
    return <serviceContext.Provider value={context}>{children}</serviceContext.Provider>;
}

export function useService() {
    return useContext(serviceContext);
}
